








































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TUploadHistoryPage } from '@/types/utils';
@Component({
  components: {
    History: () => import('./history.vue')
  }
})
export default class Xls extends Vue {
  @Prop({
    type: Function,
    default() {
      return function() {};
    },
    required: true
  })
  reload!: Function;
  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  attr!: Object;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleSuccess!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleError!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    },
    required: true
  })
  getUploadHistory!: Function;
  private dialogVisible = false;
  private fileList: any[] = [];
  // private uploadData = {};
  private uploadUrl = '';
  private uploadHistoryPage: TUploadHistoryPage = {
    currentPage: 1,
    pageSize: 100
  };

  private activated () {
    // this.addParams();
    this.setUploadUrl();
  }
  /**
   * @description: 设定el-upload的值
   */
  private setUploadUrl() {
    this.uploadUrl = process.env.VUE_APP_API + '/org/importLeads';
  }

  // /**
  //  * @description: 设定需随xls文件提交的参数
  //  */
  // private addParams() {
  //   if (!this.attr) return;
  //   this.uploadData = {...this.uploadData, ...this.attr}
  // }
  handleClose() {
    this.dialogVisible = false;
    (this.$refs.upload as any).clearFiles();
  }
  private async openHistory() {
    try {
      this.uploadHistoryPage = await this.getUploadHistory();
      (this.$refs.historyDialog as any).dialogVisible = true;
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  downTemplate() {
    window.open(process.env.VUE_APP_API + '/org/downTemplate');
  }
}
